export enum PermissionType {
  Role = 0,
  UserCreditorRole = 1,
  Permission = 2,
}
